(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/router/assets/javascripts/marketplace-onboarding.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/router/assets/javascripts/marketplace-onboarding.js');

'use strict';

const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  Paper = _svs$ui.ReactPaper;
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const Hero = svs.components.marketplace.hero.Hero;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const MarketplaceOnboarding = () => {
  const size = useMediaQuery(breakpoints.down(BREAKPOINT_MD)) ? 700 : 900;
  return React.createElement(React.Fragment, null, React.createElement(WidgetArea, {
    className: "marketplace-widget",
    widgetArea: "infoWidgetAreaTop"
  }), React.createElement("div", {
    className: "marketplace-onboarding-papers"
  }, React.createElement(Paper, {
    branding: "sport",
    className: "marketplace-onboarding-paper"
  }, React.createElement(Link, {
    className: "marketplace-onboarding-link qa-onboarding-together-link",
    to: "/lag"
  }, React.createElement(Icon, {
    color: "fc-sport-75",
    icon: "players",
    size: size
  }), React.createElement("h3", null, "Spela i lag p\xE5 n\xE5gra av v\xE5ra mest popul\xE4ra spel"))), React.createElement(Paper, {
    branding: "sport",
    className: "marketplace-onboarding-paper"
  }, React.createElement(Link, {
    className: "marketplace-onboarding-link qa-onboarding-retail-link",
    to: "/ombudslag"
  }, React.createElement(Icon, {
    color: "fc-sport-75",
    icon: "andelsspel",
    size: size
  }), React.createElement("h3", null, "K\xF6p butiksandelar och ta del av experternas strategier")))), React.createElement(WidgetArea, {
    className: "marketplace-widget",
    widgetArea: "infoWidgetArea"
  }));
};
setGlobal('svs.marketplace.components.router.MarketplaceOnboarding', MarketplaceOnboarding);

 })(window);